import React from "react";
import DOMPurify from "dompurify";

export default function HtmlSanitiser(props: any) {
  const clean = DOMPurify.sanitize(props.content, {FORBID_TAGS: ['style']});

  return <div dangerouslySetInnerHTML={{ __html: clean }}></div>;
}
